angular.module('app.directives.schedule').directive('podcastSettings', () => {
  return {
    restrict: 'E',
    scope: {
      broadcast: '=',
      onUploadPreviewImage: '&',
    },
    link: function (scope, element, attrs) {
      // unwrap the function
      scope.onUploadPreviewImage = scope.onUploadPreviewImage();
    },
    template: require('./podcast-settings.html'),
  };
});



// WEBPACK FOOTER //
// ./app/directives/schedule/podcast-settings.js